import React, { Suspense, lazy } from "react";
import { withRouter } from 'react-router-dom';
import ContentWrapper from "./../../template/Layout/ContentWrapper";
import { Tab } from 'semantic-ui-react';
// import StandarReports from  './StandarReports'
const StandarReports = lazy(() => import('./StandarReports'))
const MyReports = React.lazy(() => import('./MyReports/List'));
const SharedReports = React.lazy(() => import('./SharedReports'));

function Reports(props) {
  return (
    <ContentWrapper>
      <div className="content-heading">
        <em className="fas fa-1x mr-2 fas fa-table" />
          My Reports
      </div>
      <Tab
        menu={{ secondary: true }}
        panes={[
          { menuItem: 'Standard Reports', render: () => <Suspense fallback={<div>Loading...</div>}> <StandarReports type="Standard" _user={props._user} /></Suspense> },
          { menuItem: 'My Reports', render: () => <Suspense fallback={<div>Loading...</div>}> <MyReports type="MyReports" user={props._user} /></Suspense> },
          { menuItem: 'Shared Reports', render: () => <Suspense fallback={<div>Loading...</div>}> <SharedReports type="SharedReports" user={props._user} /></Suspense> }
        ]}
      />
    </ContentWrapper>
  );
}

export default withRouter(Reports);
